import React from 'react';

import { useAdContext } from '../../../store/contexts/ad';

import { Subtitle, Title, LoadingShimmer } from '@icarros/ids-react';

import { formatFabricationAndModelYear } from '../../../utils/formatters';

import { ResumeVehicleTitle } from './style';

export function VehicleTitle(): JSX.Element {
  const { currentAd } = useAdContext();

  const { marca, modelo, versao, anoFabricacao, anoModelo } = currentAd?.veiculo || {};

  return (
    <ResumeVehicleTitle>
      <LoadingShimmer show={!currentAd} width="280px" height="32px">
        <Title size="variant" contrast="light">
          {marca?.nome} {modelo?.nome}
        </Title>
      </LoadingShimmer>
      <LoadingShimmer show={!currentAd} width="340px" height="24px">
        <Subtitle>
          {versao?.nome} {formatFabricationAndModelYear(anoFabricacao, anoModelo)}
        </Subtitle>
      </LoadingShimmer>
    </ResumeVehicleTitle>
  );
}
